/* tslint:disable */
/* eslint-disable */
/**
 * Spring API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrderType } from './OrderType';
import {
    OrderTypeFromJSON,
    OrderTypeFromJSONTyped,
    OrderTypeToJSON,
    OrderTypeToJSONTyped,
} from './OrderType';
import type { ScheduledTask } from './ScheduledTask';
import {
    ScheduledTaskFromJSON,
    ScheduledTaskFromJSONTyped,
    ScheduledTaskToJSON,
    ScheduledTaskToJSONTyped,
} from './ScheduledTask';

/**
 * 
 * @export
 * @interface ScheduledBlock
 */
export interface ScheduledBlock {
    /**
     * 
     * @type {Array<ScheduledTask>}
     * @memberof ScheduledBlock
     */
    scheduledTasks: Array<ScheduledTask>;
    /**
     * 
     * @type {number}
     * @memberof ScheduledBlock
     */
    blockDurationSeconds: number;
    /**
     * 
     * @type {OrderType}
     * @memberof ScheduledBlock
     */
    tasksOrderType: OrderType;
}



/**
 * Check if a given object implements the ScheduledBlock interface.
 */
export function instanceOfScheduledBlock(value: object): value is ScheduledBlock {
    if (!('scheduledTasks' in value) || value['scheduledTasks'] === undefined) return false;
    if (!('blockDurationSeconds' in value) || value['blockDurationSeconds'] === undefined) return false;
    if (!('tasksOrderType' in value) || value['tasksOrderType'] === undefined) return false;
    return true;
}

export function ScheduledBlockFromJSON(json: any): ScheduledBlock {
    return ScheduledBlockFromJSONTyped(json, false);
}

export function ScheduledBlockFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScheduledBlock {
    if (json == null) {
        return json;
    }
    return {
        
        'scheduledTasks': ((json['scheduled_tasks'] as Array<any>).map(ScheduledTaskFromJSON)),
        'blockDurationSeconds': json['block_duration_seconds'],
        'tasksOrderType': OrderTypeFromJSON(json['tasks_order_type']),
    };
}

export function ScheduledBlockToJSON(json: any): ScheduledBlock {
    return ScheduledBlockToJSONTyped(json, false);
}

export function ScheduledBlockToJSONTyped(value?: ScheduledBlock | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'scheduled_tasks': ((value['scheduledTasks'] as Array<any>).map(ScheduledTaskToJSON)),
        'block_duration_seconds': value['blockDurationSeconds'],
        'tasks_order_type': OrderTypeToJSON(value['tasksOrderType']),
    };
}

